import { State } from 'country-state-city'
import { useState, useEffect, useRef } from 'react'
import Select from 'react-select'

const formatStateValue = value => {
  if (!value || value === 'Select State') return null
  return {
    label: value,
    value,
    field: 'state'
  }
}

const StateProvinceSelect = ({ countryCode, handleChangeState, stateValue, placeholder = 'Select State' }) => {
  const [statesOfCountry, setStatesOfCountry] = useState([])
  const [selectedState, setSelectedState] = useState(() => formatStateValue(stateValue))
  const isUserSelection = useRef(false)

  useEffect(() => {
    if (isUserSelection.current) {
      handleChangeState(selectedState)
      isUserSelection.current = false
    }
  }, [selectedState])

  useEffect(() => {
    setStatesOfCountry(State.getStatesOfCountry(countryCode))
  }, [countryCode])

  useEffect(() => {
    if (!stateValue || stateValue === 'Select State') {
      setSelectedState(null)
      return
    }

    const matchingState = statesOfCountry.find(s => s.isoCode === stateValue || s.name === stateValue)
    setSelectedState({
      label: matchingState?.name || stateValue,
      value: matchingState?.isoCode || stateValue,
      field: 'state'
    })
  }, [stateValue, statesOfCountry])

  const statesOptions = statesOfCountry.map(state => {
    return {
      label: state.name,
      value: state.isoCode,
      field: 'state'
    }
  })

  const handleUserSelect = newState => {
    isUserSelection.current = true
    setSelectedState(newState)
  }

  return (
    <Select
      name="state"
      value={selectedState}
      isClearable={false}
      options={statesOptions}
      onChange={handleUserSelect}
      placeholder={placeholder}
    />
  )
}

export default StateProvinceSelect
